import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EcliSettings } from '../models/settings.model';
import { GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';

const __URL_API__ = `${environment.URL_API}`;

@Injectable({ providedIn: 'root' })
export class SettingService {
  private _http = inject(HttpClient);
  private notificationService = inject(GS1NotificationService);
  private translate = inject(TranslateService);

  getSettings(): Observable<EcliSettings> {
    return this._http
      .get<EcliSettings>(`${__URL_API__}api/EcliSettings`)
      .pipe(catchError((err) => this.handleError(err, 'GlobalErrors.default')));
  }

  private handleError(error: any, message?: string): Observable<never> {
    if (message) {
      this.notificationService.addNotification(this.translate.instant(message), 'error');
    }
    return throwError(() => error.message || error);
  }
}
